import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Get status
 * @returns {JSX.Element}
 */
const CourseListItemVenue = ({ venues }) => {
	return (
		<div className="course-list__item__content-venue">
			<span>{__('Location', 'kotisivu-block-theme')}</span>
			<div>
				{venues.map((venue, index) => {
					return (
						<span key={`${venue.id}-${venue.slug}-${index}`}>
							{decodeEntities(venue.name)}
						</span>
					);
				})}
			</div>
		</div>
	);
};

export default CourseListItemVenue;
